import React, { useState } from 'react';
import { Alert, Button, Col, Container, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../layout/header/Header';
import Footer from '../../layout/footer/Footer';
import '../auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!email) {
      setMessage('Please enter your email address.');
      return;
    }

    setMessage('Password reset support is active through customer care. Please contact support with your registered email.');
  };

  return (
    <>
      <Header />
      <section className="arkab-auth-hero">
        <Container>
          <h1>Forgot Password</h1>
          <p>Recover access to your account securely.</p>
        </Container>
      </section>
      <Container className="mt-5 mb-5 arkab-auth-shell">
        <Row className="justify-content-center">
          <Col md={8} lg={7}>
            <div className="arkab-auth-card">
            <h2 className="text-center mb-4">Forgot Password</h2>
            <p className="text-muted">
              Enter your customer email and we will guide you through password reset.
            </p>
            {message && <Alert variant="info">{message}</Alert>}

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="forgotPasswordEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your registered email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  required
                />
              </Form.Group>

              <div className="d-grid mb-3">
                <Button type="submit" variant="dark" className="arkab-auth-primary-btn">Continue</Button>
              </div>

              <div className="text-center">
                <Link to="/login">Back to login</Link>
              </div>
            </Form>
            </div>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
};

export default ForgotPassword;
